import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, TablePagination, Box, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {useNavigate} from 'react-router-dom';
import { partnersAPI } from '../../Api';
import PlumSvg from '../component/PlumSvg'; // Если у вас есть этот компонент

const PartnersList =  () => {
    const navigate = useNavigate();
  // Состояние для данных пользователей
  const [partners, setPartners] = useState([]);

  // Стейт для пагинации
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  useEffect(() => {
    const fetchpartners = async () => {
      try {
        const response = await partnersAPI.getPartners();
        console.log(response.data)
        setPartners(response.data.data);
      } catch (error) {
        console.error('Error fetching partners:', error);
      }
    };
    fetchpartners();
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Функции для редактирования и удаления
  const handleEdit = (id) => {
    navigate("/partners/edit/" + id)
    console.log('Редактировать пользователя с id:', id);
  };

  const handleDelete = async (id) => {
    let partner = await partnersAPI.deletePartner(id);
    console.log(partner)
    if(partner.data.success){
        setPartners(partners.filter(partner => partner._id !== id));
    }
  };

  return (
    <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2, bgcolor: "#fefcfb" }}>
      <Typography variant="h5" align="center" gutterBottom>
        <PlumSvg /> Список пользователей
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Название</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Основной</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>FunPay</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Yandex</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Действия</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#683d62' }}>Прокси</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {partners.map((partner) => (
              <TableRow key={partner.id}>
                <TableCell>{partner.name}</TableCell>
                <TableCell>{(partner.basic ? 'Да' : 'Нет')}</TableCell>
                <TableCell>{((partner.FunPay?.cookies.length > 0) ? 'Да' : 'Нет')}</TableCell>
                <TableCell>{(partner.Yandex ? 'Да' : 'Нет')}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(partner._id)} sx={{ color: '#683d62' }}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(partner._id)} sx={{ color: '#683d62' }}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
                <TableCell>{(partner.proxy ? 'Да' : 'Нет')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={partners.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            "& .MuiTablePagination-select": {
              color: "#683d62",
            },
            "& .MuiTablePagination-toolbar": {
              backgroundColor: "#fefcfb",
            },
            "& .MuiTablePagination-spacer": {
              display: 'none',
            },
            "& .MuiTablePagination-actions": {
              color: "#683d62",
            },
          }}
        />
      </TableContainer>
    </Box>
  );
};

export default PartnersList;
